import axios from '../lib/axios'
import { buildUrlString } from '@!/Util'

export const getRankingApi = async (safeSearch, rankingType, page, perPage) => {
  const url = buildUrlString(`/api/v1/rankings`, { safe_search: safeSearch, ranking_type: rankingType, page: page, per_page: perPage })
  return await axios.get(url)
}
